/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_MutterspracheInputs */

const en__field_muttersprache = /** @type {(inputs: _Field_MutterspracheInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Native Language`)
};

const de__field_muttersprache = /** @type {(inputs: _Field_MutterspracheInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muttersprache`)
};

/**
* | output |
* | --- |
* | "Native Language" |
*
* @param {_Field_MutterspracheInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_muttersprache = /** @type {((inputs?: _Field_MutterspracheInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_MutterspracheInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_muttersprache(inputs)
	return de__field_muttersprache(inputs)
});